import {types} from "mobx-state-tree";

export const BatchItemQrModel = types
	.model({
		uuid: types.string,
		name: types.maybeNull(types.string)
	});
